export const GrowthMarginBridgeCardData = [
    {
        metricName: 'Base',
        absoluteValue: 76000,
        percentChange: 10,
        changedVal: 7.6,
    },
    {
        metricName: 'Final',
        absoluteValue: 76000,
        percentChange: 10,
        changedVal: 7.6,
    },
    {
        metricName: 'Growth',
        absoluteValue: 76000,
        percentChange: 10,
        changedVal: 7.6,
    },
    {
        metricName: 'Growth %',
        absoluteValue: 76000,
        percentChange: 10,
        changedVal: 7.6,
    },
];
